const HTML_TAG_RE = /<\/?[a-z][\s\S]*>/i;
const HEADING_RE = /^[A-ZÁÀÂÃÉÈÊÍÌÎÓÒÔÕÚÙÛÇ0-9][A-ZÁÀÂÃÉÈÊÍÌÎÓÒÔÕÚÙÛÇ0-9 /()\-–—.:]{2,}$/;

const escapeHtml = (value) => String(value || '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

export const ensureRichText = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (HTML_TAG_RE.test(raw)) return raw;

  return raw
    .replace(/\r\n/g, '\n')
    .split('\n')
    .map((line) => {
      const trimmed = line.trim();
      if (!trimmed) return '<p><br></p>';
      const safe = escapeHtml(trimmed);
      return HEADING_RE.test(trimmed)
        ? `<p><strong>${safe}</strong></p>`
        : `<p>${safe}</p>`;
    })
    .join('');
};
